/**
 * @Description 益禾堂营业额预估(个人预估)
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132274569
 */

import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { readInDataWhenTargetHide, setComValue } from '../../config';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';

interface EstimateSalesPersonalProps {
  propertyItem: any;
  required: boolean;
  disabled: boolean;
  tiledFormDataRef: any;
}
const EstimateSalesPersonal: FC<EstimateSalesPersonalProps> = ({
  propertyItem,
  required,
  disabled,
  tiledFormDataRef,
}) => {
  const methods = useMethods({
    handleNumInputChange: (val: number) => {
      setComValue(propertyItem, val);
      readInDataWhenTargetHide(tiledFormDataRef.current, {
        label: `${val}元（${propertyItem?.anotherName || propertyItem?.name}）`,
        value: propertyItem?.identification,
        detailShowVal: `${val}元`,
        countValue: val, // 服务端用
      });
    }
  });
  return (
    <V2FormInputNumber
      label={propertyItem?.anotherName || propertyItem?.name}
      name={propertyItem?.identification}
      placeholder='输入内容'
      max={999999999}
      required={required}
      disabled={disabled}
      config={{
        addonAfter: '元',
      }}
      onChange={(val: any) => methods.handleNumInputChange(val)}
    />
  );
};

export default EstimateSalesPersonal;
